import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'
import { Player } from 'shikwasa'
import 'shikwasa/dist/style.css'

import { library } from '@fortawesome/fontawesome-svg-core'

import { faLink } from '@fortawesome/free-solid-svg-icons'
import { faLinkedinIn, faWhatsapp } from '@fortawesome/free-brands-svg-icons'

import LatestPosts from './LatestPosts/index.vue'
import Search from './Search/index.vue'
import Podcasts from './Podcasts/index.vue'
import api from '@/helpers/fetch'

library.add(faLink, faLinkedinIn, faWhatsapp)

@Component({
	components: {
		Loader,
		vSelect,
		LatestPosts,
		Search,
		Podcasts,
	},
})
export default class Blog extends Vue {
	form = {
		tag: [] as Array<any>,
	}

	options = {
		tags: [] as Array<any>,
	}

	openLink(url) {
		window.open(url, '_blank')
	}

	mounted() {
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)
	}
}
